module.exports = __webpack_public_path__ + "img/play-button.2cb25000.png";